const mediaItems = [
  {
    image: "https://readdy.ai/api/search-image?query=Cinematic%20dark%20abstract%20scene%20with%20dramatic%20warm%20lighting%2C%20video%20player%20aesthetic%2C%20entertainment%20news%20theme%2C%20no%20faces%2C%20modern%20digital%20media%20composition&width=640&height=360&seq=media-01-video&orientation=landscape",
    title: '网红翻车名场面大合集：这些操作太离谱了',
    duration: '08:42',
    views: '128.6万',
    date: '2小时前',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20composition%20with%20orange%20red%20highlights%2C%20cinematic%20video%20thumbnail%20style%2C%20entertainment%20media%20theme%2C%20no%20faces%2C%20dramatic%20lighting&width=640&height=360&seq=media-02-video&orientation=landscape",
    title: '某知名艺人私下真实面目曝光，粉丝都看傻了',
    duration: '12:15',
    views: '96.3万',
    date: '5小时前',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20cinematic%20background%20with%20dramatic%20shadow%20play%2C%20video%20media%20aesthetic%2C%20entertainment%20industry%20theme%2C%20no%20faces%2C%20modern%20design&width=640&height=360&seq=media-03-video&orientation=landscape",
    title: '综艺录制现场突发状况，嘉宾当场翻脸全过程',
    duration: '06:38',
    views: '85.7万',
    date: '8小时前',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20digital%20art%20with%20warm%20coral%20accents%2C%20video%20player%20theme%2C%20media%20news%20vibe%2C%20no%20faces%2C%20bold%20cinematic%20composition&width=640&height=360&seq=media-04-video&orientation=landscape",
    title: '某电商大促直播间主播与品牌方当场互撕',
    duration: '05:21',
    views: '73.2万',
    date: '12小时前',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Stylized%20dark%20cinematic%20abstract%20scene%20with%20warm%20golden%20highlights%2C%20video%20entertainment%20media%20theme%2C%20no%20faces%2C%20dramatic%20composition%20modern%20design&width=640&height=360&seq=media-05-video&orientation=landscape",
    title: '素人爆料：健身房私教骚扰女学员监控外泄',
    duration: '03:57',
    views: '62.8万',
    date: '1天前',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
              精选视频
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              视频专区
            </h2>
          </div>
          <a
            href="#index"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            更多视频 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.slice(0, 3).map((item, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-colors cursor-pointer group"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-400 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 bg-foreground-950/80 text-background-100 text-xs px-1.5 py-0.5 rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {mediaItems.slice(3).map((item, i) => (
            <article
              key={i + 3}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-colors cursor-pointer group flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-[240px] aspect-video overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-400 transition-colors">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 bg-foreground-950/80 text-background-100 text-xs px-1.5 py-0.5 rounded">
                  {item.duration}
                </span>
              </div>
              <div className="flex-1 p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}